import React, { createContext, useState, useEffect, useContext } from "react";

import { MixitContext } from "./MixitContext";

import { getNewsItems } from "../services/Services";

export const DataContext = createContext();

const pathway = window.connectString;

// check if prefiltered
let initialFilterSetting = document.querySelector("#prefilter_setting");
initialFilterSetting == null
  ? (initialFilterSetting = "")
  : (initialFilterSetting =
      "&filters[Tags][Category]=" +
      initialFilterSetting.textContent.replace(/\s/g, "%20"));

const DataContextProvider = ({ children }) => {
  const { config, mixitBuildData, sitePaths } = useContext(MixitContext);

  const [articleListPosition, setArticleListPosition] = useState(1);
  const [articles, setArticles] = useState([]); // Get data from API
  const [rawArticleTotal, setRawArticleTotal] = useState(0);
  const [mixitSetting, setMixitSetting] = useState(initialFilterSetting);
  const [dateDirection, setDateDirection] = useState("DESC");

  useEffect(() => {
    setArticles([]); // resets loading spinner

    if (config.siteName !== undefined && mixitBuildData.length !== 0) {
      let matchedCategory = mixitBuildData
        .filter((mixit) =>
          sitePaths
            .map((path) => path.toLowerCase())
            .includes(mixit.name.replace(/\s+/g, "-").toLowerCase())
        )
        .reverse()[0];

      getNewsItems(
        mixitSetting,
        articleListPosition,
        dateDirection,
        config.siteName,
        sitePaths,
        matchedCategory
      ).then((res) => {
        setArticles(res.data.data);
        setRawArticleTotal(res.data.meta.pagination.total);
      });
    }
  }, [
    articleListPosition,
    mixitSetting,
    dateDirection,
    config,
    mixitBuildData,
  ]);

  return (
    <DataContext.Provider
      value={{
        initialFilterSetting,
        setDateDirection,
        articles,
        pathway,
        mixitSetting,
        setMixitSetting,
        articleListPosition,
        setArticleListPosition,
        config,
        sitePaths,
        rawArticleTotal,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataContextProvider;
